export const state = () => ({
  userProfile: {},
  levels: [],
})

export const mutations = {
  set_userProfile(state, data) {
    state.userProfile = data
  },

  set_levels(state, data) {
    state.levels = data
  },
}

export const actions = {
  async act_fetchUserProfile({ commit }) {
    try {
      const data = await this.$smartico?.api?.getUserProfile()

      if (data) {
        commit('set_userProfile', { ...data })
      }

      return data
    }
    catch (error) {
      console.error(error)
      throw error
    }
  },

  async act_fetchLevels({ commit }) {
    try {
      const data = await this.$smartico?.api?.getLevels()

      if (Array.isArray(data)) {
        commit('set_levels', [...data])
      }

      return data
    }
    catch (error) {
      console.error(error)
      throw error
    }
  },
}

export const getters = {
  get_userProfile: state => state.userProfile,
  get_levels: state => [...state.levels].sort((a, b) => (a?.required_points - b?.required_points)),
}
